var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"w3-button w3-text-theme",attrs:{"type":"button"},on:{"click":function($event){_vm.$emit('clear')}}},[_c('font-awesome-icon',{attrs:{"icon":['far', 'undo-alt']}}),_vm._v(" Clear\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }